
import receivedIcon from './../../assets/received.png';
import notJoinIcon from './../../assets/notJoin.png';
import notCompleteIcon from './../../assets/joined.png';
import notReceiveIcon from './../../assets/icon3.gif';

import { PayActType } from './business/pay-act';
import { ActivityCouponState, CouponState } from '@tencent/wphk-act-base-types';
import { TaskReceiveStatus } from './hooks/use-task-info';
import { ExchButtonStatus } from '@/types/exch-info';

const getMock = (key: string) => {
  const mockVal = (window as any).__mockSpringAct?.[key];
  return mockVal;
};

export const getTaskName = (taskName?: string) => getMock('TASK_NAME') || taskName;
export const COUPON_SORT_STATE = [
  ActivityCouponState.expired,
  ActivityCouponState.used,
  ActivityCouponState.received,
  ActivityCouponState.totalLimit,
  ActivityCouponState.dayLimit,
  ActivityCouponState.avaliable,
];

/** 获取格式化活动配置 */
export const getFormattedExchActConfigs = (exchList: string[], signInActId: string) => {
  const AUTO_RECEIVE_EXCH_CONFIG = {
    actType: PayActType.exch,
    enActId: getMock('autoReceive') || decodeURIComponent(signInActId),
  };
  const exchConfigs = exchList.map(enActId => ({
    actType: PayActType.task,
    enActId: decodeURIComponent(enActId) }));
  return [AUTO_RECEIVE_EXCH_CONFIG].concat(exchConfigs);
};

/** 任务图标配置 */
export const ICON_CONFIG: { [key in TaskReceiveStatus]: any } = {
  [TaskReceiveStatus.Received]: receivedIcon,
  [TaskReceiveStatus.notJoin]: notJoinIcon,
  [TaskReceiveStatus.notComplete]: notCompleteIcon,
  [TaskReceiveStatus.notReceive]: notReceiveIcon,
};
/** 券详情弹窗的按钮状态文案 */
export const DETAIL_DIALOG_BTN_TEXT = {
  [ExchButtonStatus.ToReceive]: '立即領取',
  [ExchButtonStatus.IsLocked]: '待解鎖',
  [ExchButtonStatus.ToUse]: '去使用',
  [ExchButtonStatus.Hidden]: '',
  [ExchButtonStatus.IsLimit]: '今日已領完',
};

/** 券面水印文案 */
export const COUPON_STAMP_TEXT = {
  [CouponState.received]: '已領取',
  [CouponState.used]: '已使用',
  [CouponState.expired]: '已過期',
};
